<template>
    <h2>Products</h2>
    <router-view />
</template>

<script>
export default {
    
}
</script>